import React from 'react';
import { cn } from '@/lib/utils';
import { WHATSAPP_NUMBER_DISPLAY, WHATSAPP_SUPPORT_URL } from '@/lib/support';
import WhatsAppButton from './WhatsAppButton';
import WhatsAppIcon from './WhatsAppIcon';

interface WhatsAppContactCardProps {
  title: string;
  description: string;
  /** Optional pre-filled WhatsApp link, e.g. quoting a claim ID. */
  href?: string;
  className?: string;
}

/**
 * WhatsApp support card (Figma "Contact card"). Claims can be filed only on the dashboard
 * or WhatsApp — never label email as a claim channel.
 */
const WhatsAppContactCard: React.FC<WhatsAppContactCardProps> = ({ title, description, href = WHATSAPP_SUPPORT_URL, className }) => (
  <section className={cn('tw-flex tw-flex-col tw-gap-3 tw-rounded-2xl tw-bg-ds-surface tw-p-[18px]', className)}>
    <span className="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-full tw-bg-ds-whatsapp-bg">
      <WhatsAppIcon size={22} />
    </span>
    <div className="tw-flex tw-flex-col tw-gap-0.5">
      <h2 className="tw-text-[15px] tw-font-semibold tw-leading-5 tw-text-ds-text-primary">{title}</h2>
      <p className="tw-text-[13px] tw-leading-[18px] tw-text-ds-text-secondary">{description}</p>
    </div>
    <p className="tw-text-[15px] tw-font-semibold tw-leading-5 tw-text-ds-text-primary">{WHATSAPP_NUMBER_DISPLAY}</p>
    <WhatsAppButton href={href} />
  </section>
);

export default WhatsAppContactCard;
